import { IOptionType } from '../enum/IOptionType';
import { FeatureType } from '../enum/FeatureType';

export interface IOptionTypes {
  [key: string]: IOptionType;
}

const featureCategoryTypeService = {
  getFeatureCategoryType: (featureCategoryType: FeatureType): IOptionType => {
    const optionTypes: IOptionTypes = {
      [FeatureType.mutex0]: IOptionType.RADIO,
      [FeatureType.mutex1]: IOptionType.CHECKBOX,
      [FeatureType.multi]: IOptionType.MULTISELECT,
    };

    return optionTypes[featureCategoryType];
  },
};

export default featureCategoryTypeService;
